import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { FulfillmentService } from "@redotech/redo-model/fulfillments/fulfillment-group";
import { OrderManagementPermissions } from "@redotech/redo-model/permissions";
import { createContext, memo, ReactNode } from "react";
import { RedoOutboundLabelsRpcClientContext } from "../outbound-labels-rpc-client";

export const AssignedFulfillmentServiceContext =
  createContext<FulfillmentService | null>(null);
export const AssignedFulfillmentServiceService = memo(
  function AssignedFulfillmentServiceService({
    children,
  }: {
    children: ReactNode | ReactNode[];
  }) {
    const client = useRequiredContext(RedoOutboundLabelsRpcClientContext);

    const canSeeFulfillmentServices = useHasPermission(
      OrderManagementPermissions.SCAN_AND_VERIFY,
    );

    const loadState = useLoad(
      async (signal) => {
        if (!canSeeFulfillmentServices) {
          return null;
        }
        const result = await client.getFulfillmentServiceForTeam(
          {},
          { signal },
        );
        return result.fulfillmentService ?? null;
      },
      [client, canSeeFulfillmentServices],
    );

    return (
      <AssignedFulfillmentServiceContext.Provider
        value={loadState.value ?? null}
      >
        {children}
      </AssignedFulfillmentServiceContext.Provider>
    );
  },
);
